import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { FormValues } from '../CurrentYearAssumptionSettings.meta';
import { useRouteParams } from '../hooks/useRouteParams';
import { MESSAGES } from '../../../CommonConstants';
import { selectCurrentClient } from '../../../CommonSelectors/CommonAreaSelector';

const URLS_MAP = {
  ClientSettings: 'consumer/ClientSettingsUpdate/SaveCurrentYearAssumptions',
  MySettings: 'adviser/settings/CurrentYearMyAssumptions',
  FirmSettings: 'adviser/settings/CurrentYearFirmAssumptions',
};

const currentYearAssumptionSave = (url: string, clientId?: number) => (params: FormValues) =>
  authFetch(url, {
    method: 'POST',
    ...httpBodyOptions(
      {
        ...params,
        ...(clientId ? { clientId } : {}),
      },
      true,
    ),
  });

export const useCurrentYearAssumptionMutation = () => {
  const currentClient = useSelector(selectCurrentClient);
  const { page } = useRouteParams();

  return useMutation((params: FormValues) => {
    if (currentClient?.Id) {
      return currentYearAssumptionSave(URLS_MAP.ClientSettings, currentClient.Id)(params);
    }

    if (page) {
      return currentYearAssumptionSave(URLS_MAP[page])(params);
    }

    throw new Error(MESSAGES.GENERIC_ERROR);
  });
};
